import { Chip, HSpacer, MenuItem, Text } from '@/components/DesignSystem';
import { getProgramPeriodLabel, sortPrograms } from '@/pages/RetailerOverview/helpers';
import { ApiRewardsProgram } from '@api/interfaces/ApiRewardsProgram';
import ArrowDropDown from '@mui/icons-material/ArrowDropDown';
import Check from '@mui/icons-material/Check';
import { Menu, Stack, useTheme } from '@mui/material';
import React, { useState } from 'react';

interface ProgramPeriodFilterChipProps {
  onSelectProgram: (program: ApiRewardsProgram) => void;
  programs: ApiRewardsProgram[];
  selectedProgram?: ApiRewardsProgram;
  testID: string;
}

export const ProgramPeriodFilterChip = ({
  onSelectProgram,
  programs,
  selectedProgram,
  testID,
}: ProgramPeriodFilterChipProps) => {
  const theme = useTheme();
  const [anchorEl, setAnchorEl] = useState<HTMLDivElement | null>(null);
  const sortedPrograms = sortPrograms(programs);
  const isMultiple = programs.length > 1;

  if (!programs.length) return null;

  const label = selectedProgram ? getProgramPeriodLabel(selectedProgram) : '';

  return (
    <>
      <Chip
        label={
          <Stack alignItems="center" direction="row">
            <Text category="label-large" testID={`${testID}-label`}>
              {label}
            </Text>
            {isMultiple && (
              <>
                <HSpacer size="3" />
                <ArrowDropDown sx={{ height: '18px', marginRight: '-4px', width: '18px' }} />
              </>
            )}
          </Stack>
        }
        onClick={isMultiple
          ? (e: React.MouseEvent<HTMLDivElement>) => setAnchorEl(e.currentTarget)
          : undefined}
        size="medium"
        sx={{
          '&:hover': { backgroundColor: isMultiple ? theme.palette.primaryContainer : undefined },
          backgroundColor: theme.palette.primaryContainer,
          borderColor: '#bdbdbd',
          cursor: isMultiple ? 'pointer' : 'default',
        }}
        testID={testID}
        variant="filled"
      />
      {!!anchorEl && (
        <Menu
          PaperProps={{
            style: {
              borderRadius: '12px',
              marginTop: '12px',
              minWidth: '240px',
              padding: '4px 0',
            },
          }}
          anchorEl={anchorEl}
          data-testid={`${testID}-menu`}
          onClose={() => setAnchorEl(null)}
          open
        >
          {sortedPrograms.map((program) => {
            const isSelected = program.id === selectedProgram?.id;
            return (
              <MenuItem
                key={program.id}
                onClick={() => {
                  onSelectProgram(program);
                  setAnchorEl(null);
                }}
                sx={{ padding: '8px 16px' }}
                testID={`${testID}-option-${program.id}`}
                value={program.id}
              >
                <Stack alignItems="center" direction="row" gap={1}>
                  <Check sx={{ opacity: isSelected ? 1 : 0, width: '18px' }} />
                  <Text category="body-large">
                    {getProgramPeriodLabel(program)}
                  </Text>
                </Stack>
              </MenuItem>
            );
          })}
        </Menu>
      )}
    </>
  );
};
